import { useState } from 'react';
import styled from 'styled-components';
import ProductDetails from './ProductDetails';

const ProductsSection = styled.section`
  padding: 80px 50px;
  background-color: #f8f9fa;
  width: 100%;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const Title = styled.h2`
  text-align: center;
  color: #1d3557;
  margin-bottom: 40px;
  font-size: 2.5rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const ProductCard = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s ease;

  ${ProductCard}:hover & {
    transform: scale(1.05);
  }
`;

const ProductInfo = styled.div`
  padding: 20px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ProductName = styled.h3`
  color: #1d3557;
  margin-bottom: 10px;
  font-size: 1.2rem;
`;

const ProductPrice = styled.p`
  color: #e63946;
  font-weight: bold;
  font-size: 1.1rem;
  margin-top: auto;
`;

const Products = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const products = [
    {
      id: 1,
      name: 'Ordinateur Portable HP I7',
      price: '750 $',
      image: 'https://www.hp.com/fr-fr/shop/Html/Merch/Images/9Q246EA-ABF_1_1750x1285.jpg',
      description: 'Ordinateur Portable HP I7 Système d\'exploitation Windows 11 Famille Processeur Intel® Core™ i7 1355U (13ème génération) Mémoire 16 Go RAM Stockage 1 To Disque SSD Écran 43,9 cm (17,3 pouces), FHD (1920 x 1080) Carte graphique Carte graphique Intel® Iris® Xᵉ.'
    },
    {
      id: 2,
      name: 'Ordinateur Portable LENOVO ',
      price: '500 $',
      image: 'https://p1-ofp.static.pub//fes/cms/2024/07/17/072qc6ainvtod7syg4tyfato3zpjlb892347.png',
      description: 'Ordinateur Portable LENOVO I7.'
    },
    {
      id: 3,
      name: 'Papier Duplicateur Paper One A4',
      price: '24.5 $',
      image: 'https://images.unsplash.com/photo-1589330694653-ded6df03f754',
      description: 'Papier multifonction de haute qualité, parfait pour l\'impression et la photocopie. Format A4 standard, 80g/m².'
    },
    {
      id: 4,
      name: 'Imprimante Jeu d\'encre HP DeskJet 2320',
      price: '47 $',
      image: 'https://th.bing.com/th/id/OIP._r-c92U3IhEcVEEv1p5b3wHaE3?rs=1&pid=ImgDetMain',
      description: 'L\'imprimante HP DeskJet2320 est une imprimante à jet d\'encre abordable et polyvalente pour un usage personnel ou professionnel. Elle offre une qualité d\'impression élevée avec une résolution maximale de 1200 x 1200 ppp pour le noir et blanc et de 4800 x 1200 ppp pour la couleur. Elle est compacte et facile à utiliser, avec une interface simple et conviviale pour les utilisateurs débutants. Spécifications	Détails Type	Imprimante à jet d\'encre Technologie d\'impression	Jet d\'encre thermique HP Fonctions	Impression, numérisation, copie Vitesse d\'impression	Jusqu\'à 7,5 ppm en noir et blanc, jusqu\'à 5,5 ppm en couleur Résolution d\'impression	Jusqu\'à 1200 x 1200 ppp en noir et blanc, jusqu\'à 4800 x 1200 ppp en couleur Connectivité	USB 2.0 Capacité du bac de papier	Jusqu\'à 60 feuilles Formats de papier pris en charge	A4, B5, A6, DL Systèmes d\'exploitation compatibles Windows 11,	Windows10, Windows8.1, Windows7 SP1, macOSv10.14, macOSv10.15, macOSv11 Dimensions (L x P x H)	475 x 191 x 354 mm Poids	3,42 kg'
    },
    {
      id: 5,
      name: 'Clavier Avec Fil',
      price: '5 $',
      image: 'https://img.freepik.com/free-photo/top-computer-keyboard_1260-14.jpg?ga=GA1.1.1335888468.1737368195&semt=ais_incoming',
      description: 'Clavier ergonomique avec fil. Design moderne et confortable.'
    },
    {
      id: 6,
      name: 'Disk Dur Externe 2TB',
      price: '80 $',
      image: 'https://img.freepik.com/free-photo/disc-disk-port-copy-data_1232-4119.jpg?ga=GA1.1.1335888468.1737368195&semt=ais_incoming',
      description: 'Disk Dur Externe 2TB.'
    },
    {
      id: 7,
      name: 'Famille EPSON 103',
      price: '15 $',
      image: 'https://tweakers.net/i/MnoaLMusrIRkggsvKJIPEB02vvg=/fit-in/656x/filters:strip_icc():strip_exif()/i/2004601596.jpeg?f=imagenormal',
      description: 'Famille EPSON 103.'
    },
    {
      id: 8,
      name: 'Cartouche HP 107A Originale',
      price: '65 $',
      image: 'https://cf.shopee.co.th/file/1e068180a3de2239407c96e9d6c9a04a',
      description: 'Cartouche HP 107A Originale, Catégorie de produit Encre et toner pour imprimantes, Marque HP (HP), Code de produit 13266750609.'
    },
    {
      id: 9,
      name: 'Cartouche Canon 067 Originale',
      price: '80 $',
      image: 'https://www.materiel-informatique.fr/185054-large_default/canon-067-noir-original-cartouche-de-toner.jpg',
      description: 'Cartouche Canon 067 Originale, Technologie d\'impression Laser Type de Produit Cartouche de toner Couleur d\'impression Noir Rendement Jusqu\'à 1 350 pages'
    },
    {
      id: 10,
      name: 'DESKTOP HP I5',
      price: '6009 $',
      image: 'https://img.freepik.com/premium-photo/desctop-computer-wooden-desk_488220-53335.jpg?uid=R131536909&ga=GA1.1.1335888468.1737368195&semt=ais_incoming',
      description: 'DESKTOP HP I5'
    },
    {
      id: 11,
      name: 'Souris Avec Fil',
      price: '3 $',
      image: 'https://img.freepik.com/premium-photo/high-angle-view-computer-mouse_1048944-3151660.jpg?uid=R131536909&ga=GA1.1.1335888468.1737368195&semt=ais_incoming',
      description: 'Souris Avec Fil'
    },
    {
      id: 12,
      name: 'Router TP Link',
      price: '120 $',
      image: 'https://img.freepik.com/free-photo/wi-fi-router-with-blue-optical-fiber_23-2148779307.jpg?uid=R131536909&ga=GA1.1.1335888468.1737368195&semt=ais_incoming',
      description: 'Router TP Link'
    },
    {
      id: 13,
      name: 'Static Control',
      price: '5 $',
      image: 'https://d:\Mes documents\Dossier Site Internet New Malamba Business\Image NMB\.jpg',
      description: 'Static Control'
    },
    {
      id: 14,
      name: 'Souris Sans Fil',
      price: '5 $',
      image: 'https://img.freepik.com/free-photo/shiny-blue-computer-mouse-modern-business-generated-by-ai_188544-27391.jpg?uid=R131536909&ga=GA1.1.1335888468.1737368195&semt=ais_incoming',
      description: 'Souris sans fil, idéale pour un usage prolongé. Capteur haute précision.'
    }
  ];

  return (
    <ProductsSection id="products">
      <Title>Nos Produits</Title>
      <ProductGrid>
        {products.map(product => (
          <ProductCard key={product.id} onClick={() => setSelectedProduct(product)}>
            <ProductImage src={product.image} alt={product.name} />
            <ProductInfo>
              <ProductName>{product.name}</ProductName>
              <ProductPrice>{product.price}</ProductPrice>
            </ProductInfo>
          </ProductCard>
        ))}
      </ProductGrid>
      {selectedProduct && (
        <ProductDetails 
          product={selectedProduct} 
          onClose={() => setSelectedProduct(null)} 
        />
      )}
    </ProductsSection>
  );
};

export default Products;